// @generated by protoc-gen-es v1.7.2
// @generated from file penumbra/core/component/distributions/v1/distributions.proto (package penumbra.core.component.distributions.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * Distribution configuration data.
 *
 * @generated from message penumbra.core.component.distributions.v1.DistributionsParameters
 */
export const DistributionsParameters = proto3.makeMessageType(
  "penumbra.core.component.distributions.v1.DistributionsParameters",
  () => [
    { no: 1, name: "staking_issuance_per_block", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * Genesis data for the distributions module.
 *
 * @generated from message penumbra.core.component.distributions.v1.GenesisContent
 */
export const GenesisContent = proto3.makeMessageType(
  "penumbra.core.component.distributions.v1.GenesisContent",
  () => [
    { no: 1, name: "distributions_params", kind: "message", T: DistributionsParameters },
  ],
);

